import(/* webpackMode: "eager" */ "/workspace/apps/ssv-home/src/app/design-guidelines/design-assets.module.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/link.js");
